import React from "react";
import PropTypes from "prop-types";
import "./AppMenu.css";

OptionAppMenu.propTypes = {
  imgSrc: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  mini: PropTypes.bool,
  url: PropTypes.string,
  showImgIcon: PropTypes.bool,
  onClick: PropTypes.func,
};

function OptionAppMenu({
  imgSrc = "http://placehold.jp/00bab4/ffffff/36.4x36.4.png",
  name = "",
  title = "",
  mini = false,
  url = "",
  onClick = () => {},
  ...props
}) {
  return (
    <div
      className="d-flex justify-content-between px-3 py-2"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div className="d-flex align-items-center nav-link">
        {mini ? (
          <span className="optionAppTextIcon">☰</span>
        ) : (
          <img className="optionAppIcon" src={imgSrc} alt={name} />
        )}
        <span className="optionAppText">{title}</span>
      </div>
    </div>
  );
}

export default OptionAppMenu;
